module.exports = __webpack_public_path__ + "static/media/faq.9c607e85.md";